export const LAG_TIMEOUT_SECONDS = 2;
